import { render, staticRenderFns } from "./AgregaSolicitante.vue?vue&type=template&id=2efda0c0"
import script from "./AgregaSolicitante.vue?vue&type=script&lang=js"
export * from "./AgregaSolicitante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2efda0c0')) {
      api.createRecord('2efda0c0', component.options)
    } else {
      api.reload('2efda0c0', component.options)
    }
    module.hot.accept("./AgregaSolicitante.vue?vue&type=template&id=2efda0c0", function () {
      api.rerender('2efda0c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AgregaSolicitante.vue"
export default component.exports